import script from "./SearchField.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchField.vue?vue&type=script&lang=ts&setup=true"

import "./SearchField.vue?vue&type=style&index=0&id=1639b0f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1639b0f4"]])

export default __exports__